module.exports = __webpack_public_path__ + "static/img/buy_help1.e020093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_help1.png
// module id = 5NQh
// module chunks = 18